export * from "./sponsor__getSponsors";
export * from "./sponsor__createBareSponsor";
export * from "./sponsor__getSingleSponsorSubscription";
export * from "./sponsor__updateSponsor";
export * from "./sponsor__uploadLogo";
export * from "./sponsor__deleteSponsor";
export * from "./sponsor__getSponsorUrl";

// i18n certified - complete
